import React from "react";
import { UserContext } from "../../contexts/UserContext";
import RouteEnum from "../../models/Enums/RouteEnum";
import HeaderMenuItem from "./HeaderMenuItem";
import useHover from "../../hooks/useHover";
import StatusDropdown from "./StatusDropdown";
import { useHistory } from "react-router-dom";
import StatusEnum from "../../models/Enums/StatusEnum";
import StartMeetingModal from "./StartMeetingModal";
import HelpIconButton, { HelpIcon } from "../webplayerscrlr/HelpIconButton";
import { SCRLR_CONFIG, setHelpPlayerUser } from "../webplayerscrlr/config";
import firebaseApi from "../../apis/firebase/firebaseApi";
import dateHelpers from "../../helpers/dateHelpers";
import config from "../../apis/firebase/config";

const Header = props => {
    let { user } = React.useContext(UserContext);
    React.useEffect(() => {
        setHelpPlayerUser(user);
    }, [user]);
    const [searchText, setSearchText] = React.useState("");
    const [showStatusDropdown, setShowStatusDropdown] = React.useState(false);
    const [showStartMeetingModal, setShowStartMeetingModal] = React.useState(false);
    const [showMobileMenu, setShowMobileMenu] = React.useState(false);
    let history = useHistory();

    let [profilePicRef, isHovered] = useHover();
    let [logoRef, isLogoHovered] = useHover();

    const onLogoClick = () => {
        history.push(RouteEnum.HOME);
        onSearchClearClick();
    }

    const getIcon = () => {
        if (!user) return null;
        let matchedStatus = Object.keys(StatusEnum).filter(x => x === user.status);
        if (!matchedStatus || !matchedStatus.length || StatusEnum[matchedStatus[0]].hideIcon) {
            return null;
        }
        return <img src={`/icons/${matchedStatus[0].toLowerCase()}.png`} style={styles.profileIcon} />;
    }

    const getNoIcon = () => {
        if (!user) return null;
        let matchedStatus = Object.keys(StatusEnum).filter(x => x === user.status);
        if (!matchedStatus || !matchedStatus.length) {
            return null;
        }
        return <img className="icon" src={`/icons/no/${matchedStatus[0].toLowerCase()}.png`} />;
    }

    const getStatusDesc = () => {
        if (!user) return null;
        let matchedStatus = Object.keys(StatusEnum).filter(x => x === user.status);
        if (!matchedStatus || !matchedStatus.length) {
            return null;
        }
        return StatusEnum[matchedStatus[0]].desc;
    }

    const onStartMeetingClick = () => {
        setShowStartMeetingModal(true);
        //window.open(user.personal_meeting_url, "_blank");
    }

    const onStartMeetingClose = () => {
        setShowStartMeetingModal(false);
    }

    const onCloseStatusDropdown = () => {
        setShowStatusDropdown(false);
        isHovered = false;
        //profilePicRef.current;
    }

    const onStatusBackClick = () => {
        let status = user.currentMeetings && user.currentMeetings.length
            ? StatusEnum.IN_MEETING.type
            : StatusEnum.ONLINE.type;

        config.analytics.logEvent("status_changed", {status: status, imBackButton: true});
        firebaseApi.updateUser(user.accountId, user.id, { status: status, timestampStatus: dateHelpers.getTimestamp() }, () => { });
    }

    const showStatusBackButton = () => {
        if (!user) return false;
        return user.status !== StatusEnum.ONLINE.type && user.status !== StatusEnum.IN_MEETING.type;
    }

    const onSearchTextChange = e => {
        setSearchText(e.target.value);
        if (props.onSearchChange) {
            props.onSearchChange(e.target.value);
        }
    }

    const onSearchClearClick = () => {
        setSearchText("");
        setShowMobileMenu(false);
        if (props.onSearchChange) {
            props.onSearchChange("");
        }
    }

    const onDialInClick = () => {
        window.open("https://zoom.us/zoomconference?m=12uppBSRbd68AK4HRyiVV9zB4O3DS4Tp", "_blank");
    }

    const onScrlrClick = () => {
        window.open("https://scrlr-web--othentic-dev.us-central1.hosted.app/", "_blank");
    }

    const onHeaderMenuClick = () => {
        setShowMobileMenu(true);
    }

    const onStatusButtonClick = () => {
        setShowStatusDropdown(!showStatusDropdown);
    }

    const onSearchClick = () => {
        props.onShowSearch();
    }

    // Close mobile menu on window resize when switching to desktop view
    React.useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1360 && showMobileMenu) {
                setShowMobileMenu(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [showMobileMenu]);

    return (
        <>
            <div className="header-container">
                <div>
                    <div className="header-icons-menu" onClick={onHeaderMenuClick}>
                        <i className="far fa-bars" />
                    </div>
                    <div className="header-icons">
                        <HeaderMenuItem
                            route={RouteEnum.COMPANY}
                            iconClass="fas fa-building"
                            name="Company"
                            label={SCRLR_CONFIG.HELP_LABELS.companyView}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            route={RouteEnum.TEAMS}
                            iconClass="fas fa-users-class"
                            name="Teams"
                            label={SCRLR_CONFIG.HELP_LABELS.teamsView}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            route={RouteEnum.MY_TEAM}
                            iconClass="fas fa-users-crown"
                            name="My Team"
                            label={SCRLR_CONFIG.HELP_LABELS.myTeamView}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            route={RouteEnum.FAQ}
                            iconClass="fas fa-question-circle"
                            name="FAQ"
                            label={SCRLR_CONFIG.HELP_LABELS.faq}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            route={RouteEnum.SETTINGS}
                            iconClass="fas fa-cog"
                            name="Settings"
                            label={SCRLR_CONFIG.HELP_LABELS.settings}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            iconClass="fas fa-phone-office"
                            name="Int. Dial-In"
                            label={SCRLR_CONFIG.HELP_LABELS.dialIn}
                            onClick={onDialInClick}
                        />
                        <HeaderMenuItem
                            iconImage="/scrl-icon-square.png"
                            name="New Post"
                            onClick={onScrlrClick}
                        />
                    </div>
                    <div ref={logoRef} style={styles.logoContainer}>
                        <img className="logo" onClick={onLogoClick} src="/IYB.png" />
                        <HelpIcon
                            className="logo-help-icon"
                            visible={isLogoHovered}
                            style={styles.helpIcon}
                        />
                    </div>
                    <div className="right-menu-search-icon">
                        {
                            props.showSearch
                                ? <i onClick={onSearchClick} className="fas fa-times" />
                                : <i onClick={onSearchClick} className="fas fa-search" />
                        }

                    </div>
                    <div className="right-menu">
                        <div>
                            <HelpIconButton
                                label={SCRLR_CONFIG.HELP_LABELS.search}
                                wrapperStyle={styles.searchContainer}
                                iconStyle={styles.searchHelpIcon}
                            >
                                <i style={styles.searchIcon} className="fas fa-search" />
                                <input
                                    style={styles.searchBox}
                                    onChange={onSearchTextChange}
                                    type="text"
                                    placeholder="Search"
                                    value={searchText}
                                />
                                {searchText.length > 0 && <i onClick={onSearchClearClick} style={styles.closeIcon} className="fas fa-times" />}
                            </HelpIconButton>
                        </div>
                        <div>
                            <HelpIconButton
                                label={SCRLR_CONFIG.HELP_LABELS.startMeetingButton}
                                iconStyle={styles.startMeetingHelpIcon}
                            >
                                <div onClick={onStartMeetingClick} className="start-meeting-button" style={styles.startMeetingButton}>Start Meeting</div>
                            </HelpIconButton>
                        </div>

                        {showStatusBackButton() && <div><div onClick={onStatusBackClick} className="status-back-button">I'm Back</div></div>}

                        <div style={styles.profilePicContainer} ref={profilePicRef}>
                            {
                                user && user.picUrl
                                    ? <img style={styles.profilePic} src={user.picUrl} />
                                    : <i className="fas fa-user-circle" />
                            }
                            {getIcon()}
                            <StatusDropdown show={isHovered} onClick={onCloseStatusDropdown} />
                            <HelpIcon
                                label={SCRLR_CONFIG.HELP_LABELS.statusButton}
                                visible={isHovered}
                                style={styles.statusHelpIcon}
                            />
                        </div>
                    </div>
                </div>
                <div className="header-line-2">
                    <div className="my-room-btn">
                        <button onClick={onStartMeetingClick} type="button" className="btn btn-ok">My Room <i className="far fa-chevron-down" /></button>
                    </div>
                    <HelpIconButton
                        label={SCRLR_CONFIG.HELP_LABELS.statusButton}
                        wrapperStyle={{ display: "block" }}
                        iconStyle={styles.mobileStatusHelpIcon}
                    >
                        <div className="status-btn" onClick={onStatusButtonClick}>
                            <div>
                                {getNoIcon()}
                                {getStatusDesc()}
                                <i className="far fa-chevron-down" />
                                <div className="profile-container">
                                    {
                                        user && user.picUrl
                                            ? <img className="profile-pic" src={user.picUrl} />
                                            : <i className="fas fa-user-circle" />
                                    }
                                </div>
                                <StatusDropdown show={showStatusDropdown} onClick={onCloseStatusDropdown} />
                            </div>
                        </div>
                    </HelpIconButton>
                </div>
            </div>
            <StartMeetingModal show={showStartMeetingModal} onClose={onStartMeetingClose} />
            {
                showMobileMenu &&
                <div className="header-menu">
                    <div className="menu">
                        <i className="far fa-times" onClick={onSearchClearClick} />
                        <HeaderMenuItem
                            route={RouteEnum.COMPANY}
                            iconClass="fas fa-building"
                            name="Company"
                            label={SCRLR_CONFIG.HELP_LABELS.companyView}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            route={RouteEnum.TEAMS}
                            iconClass="fas fa-users-class"
                            name="Teams"
                            label={SCRLR_CONFIG.HELP_LABELS.teamsView}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            route={RouteEnum.MY_TEAM}
                            iconClass="fas fa-users-crown"
                            name="My Team"
                            label={SCRLR_CONFIG.HELP_LABELS.myTeamView}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            route={RouteEnum.FAQ}
                            iconClass="fas fa-question-circle"
                            name="FAQ"
                            label={SCRLR_CONFIG.HELP_LABELS.faq}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            route={RouteEnum.SETTINGS}
                            iconClass="fas fa-cog"
                            name="Settings"
                            label={SCRLR_CONFIG.HELP_LABELS.settings}
                            onClick={onSearchClearClick}
                        />
                        <HeaderMenuItem
                            iconClass="fas fa-phone-office"
                            name="Int. Dial-In"
                            label={SCRLR_CONFIG.HELP_LABELS.dialIn}
                            onClick={onDialInClick}
                        />
                    </div>
                </div>
            }
        </>
    );
}

const styles = {
    headerContainer: {
        position: "relative",
        height: "100px",
        background: "#fff",
        width: "100%",
        textAlign: "center"
    },
    headerIcons: {
        display: "flex",
        flexDirection: "row",
        position: "absolute",
        top: "0",
        left: "10px",
        paddingTop: "10px"
    },
    iconContainer: {
        display: "flex",
        flexDirection: "column",
        fontSize: "14px",
        padding: "17px 30px",
        color: "#9F9F9F",
        cursor: "pointer"
    },
    logo: {
        cursor: "pointer",
        paddingTop: "22px",
        height: "80px",
        userSelect: "none"
    },
    logoContainer: {
        position: "relative",
        display: "inline-block",
    },
    helpIcon: {
        top: "35%",
        transform: "translateY(-50%)",
        width: "32px",
        height: "32px",
    },
    startMeetingHelpIcon: {
        right: "-14px",
        top: "12px",
        width: "24px",
        height: "24px",
    },
    statusHelpIcon: {
        right: "-4px",
        top: "2px",
        width: "24px",
        height: "24px",
    },
    mobileStatusHelpIcon: {
        right: "2px",
        top: "2px",
        width: "22px",
        height: "22px",
    },
    icon: {
        fontSize: "32px"
    },
    rightMenu: {
        position: "absolute",
        top: "0",
        right: "0",
        display: "flex",
        //alignItems: "center"
    },
    profilePic: {
        width: "70px",
        //padding: "15px",
        borderRadius: "50%"
    },
    profilePicContainer: {
        position: "relative",
        fontSize: "60px",
        color: "#666",
        padding: "15px"
    },
    profileIcon: {
        position: "absolute",
        bottom: "25px",
        right: "-5px"
    },
    startMeetingButton: {
        background: "linear-gradient(30.73deg, #2F931D 16.02%, #47C131 84.3%)",
        borderRadius: "30px",
        color: "#fff",
        fontWeight: "800",
        fontSize: "16px",
        padding: "10px 16px",
        marginTop: "27px",
        cursor: "pointer"
    },
    searchContainer: {
        position: "relative",
        marginTop: "30px",
        marginRight: "10px"
    },
    searchHelpIcon: {
        right: "-6px",
        top: "-14px",
        width: "20px",
        height: "20px",
    },
    searchIcon: {
        position: "absolute",
        top: "11px",
        left: "10px",
        color: "#666"
    },
    searchBox: {
        paddingLeft: "32px"
    },
    closeIcon: {
        position: "absolute",
        top: "11px",
        right: "10px",
        color: "#666",
        cursor: "pointer"
    }
}

export default Header;